import React from 'react'
import star from '../assets/icons/star.png'

export default function Stars({stars}) {

const styles = {'width':'1em','marginRight':'.5em'}

	return <>{[...Array(stars).keys()].map((e,i)=><img style={styles} key={i} src={star} alt='star' />)} / 5</>
}